<template>
  <a
    :href="exchange?.url"
    target="_blank"
    class="relative h-9 flex-y-center justify-center transition-300 hover:scale-110"
  >
    <img
      :src="exchange?.icon"
      alt="Exchange"
      class="object-contain"
      width="160"
      height="50"
    />
  </a>
</template>

<script setup lang="ts">
interface Props {
  exchange: {
    icon: string;
    url: string;
  };
}
defineProps<Props>();
</script>

<style scoped></style>
